import styled from "styled-components";

export const ManageEmployeePayslipModalWrapper = styled("form")(() => {
  return {
    overflow: "hidden",
    backgroundColor: "var(--color-neutral)",
    padding: "var(--cardPadding)",
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    height: "-webkit-fill-available",
    "& input, & select": {
      padding: "0.7rem 0.8rem",
      outline: "none",
      width: "100%",
      border: "1px solid var(--color-primary-hover)",
      backgroundColor: "var(--color-button-secondary)",
      borderRadius: "0.45rem",
      fontWeight: "400",
      color: "var(--color-text)",
      fontFamily: "Poppins",
      fontSize: "0.88rem",
      "&:focus": {
        border: "1px solid var(--color-primary) !important",
      },
    },
    "& select option": {
      backgroundColor: "var(--color-neutral)",
      color: "var(--color-text)",
    },
    "& fieldset": {
      flex: 1,
      overflow: "hidden",
    },
    "& .submit-button-area": {
      overflow: "hidden",
    },
    "& .close-modal-button-area": {
      overflow: "hidden",
      "& .close-modal-button": {
        width: "fit-content",
      },
      "@media screen and (min-width: 768px)": {
        display: "none",
      },
    },
    "@media screen and (min-width: 768px)": {
      height: "auto",
    },
  };
});
